export const getDigitPairsArray = code => {
  if (!code) return [];
  const array = [];
  let codeValue = code;

  while (codeValue.length > 2) {
    array.push(codeValue.substring(0, 2));
    codeValue = codeValue.substring(2);
  }

  array.push(codeValue);
  return array;
};